import React from "react"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import SEO from "../../components/Common/SEO"
import { generateCanonicalUrl } from "../../utils/seoUtils"

const AboutUs = () => {
    return (
        <React.Fragment>
            <SEO
                title="About Us | KeyQuest VR Analytics Platform"
                description="Learn about KeyQuest - the leading VR analytics and market intelligence platform for Meta Quest developers. Our mission is to empower VR creators with data-driven insights."
                keywords="VR analytics, KeyQuest about, VR market intelligence, Meta Quest analytics, VR app optimization, VR developer tools"
                canonical={generateCanonicalUrl('/about-us')}
                robots="index, follow"
            />
            <div className="page-content" style={{ backgroundColor: "#171821", minHeight: "100vh" }}>
            <Container fluid>
                {/* Hero Section */}
                <Row className="justify-content-center mb-5">
                    <Col lg={10} className="text-center">
                        <h1 className="display-4 text-white mb-4" style={{
                            fontFamily: "Rubik, sans-serif",
                            fontWeight: 700,
                            letterSpacing: "-0.02em"
                        }}>
                            Message for our VR Community
                        </h1>
                        <p className="lead" style={{
                            color: "#a1acb8",
                            fontFamily: "Rubik, sans-serif",
                            fontSize: "1.25rem"
                        }}>
                            Hey VR community <span role="img" aria-label="wave">👋</span>
                        </p>
                    </Col>
                </Row>

                {/* Introduction Section */}
                <Row className="justify-content-center mb-5">
                    <Col lg={10}>
                        <Card style={{ backgroundColor: "#21222d", border: "none", borderRadius: "12px" }}>
                            <CardBody className="p-5">
                                <p style={{
                                    color: "#fff",
                                    fontSize: "1.1rem",
                                    lineHeight: "1.8",
                                    fontFamily: "Rubik, sans-serif",
                                    marginBottom: "1.5rem"
                                }}>
                                    We’re building <strong>KeyQuest</strong> a data & intelligence platform designed specifically for VR games and apps on platforms like Meta Quest.
                                    Our goal is to help developers, studios, and publishers make better decisions using real insights, not guesswork.
                                </p>

                                <h2 className="text-white mb-3" style={{ fontFamily: "Rubik, sans-serif", fontWeight: 600, fontSize: '21.6px' }}>With KeyQuest, we’re working on:</h2>
                                <ul style={{ color: "#a1acb8", fontSize: "1.05rem", lineHeight: "1.8", fontFamily: "Rubik, sans-serif", marginBottom: "2rem" }}>
                                    <li>App & keyword tracking for VR stores</li>
                                    <li>Performance insights around downloads, revenue, rankings & trends</li>
                                    <li>Category & competitor analysis built for VR ecosystems</li>
                                    <li>Weekly insights to understand what’s working and why</li>
                                </ul>

                                <h2 className="text-white mb-3" style={{ fontFamily: "Rubik, sans-serif", fontWeight: 600, fontSize: '21.6px' }}>This community is a space to:</h2>
                                <ul style={{ color: "#a1acb8", fontSize: "1.05rem", lineHeight: "1.8", fontFamily: "Rubik, sans-serif", marginBottom: "2rem" }}>
                                    <li>Share VR market insights and trends</li>
                                    <li>Discuss store visibility, discoverability & growth</li>
                                    <li>Give feedback on KeyQuest features</li>
                                    <li>Learn from other VR builders & studios</li>
                                </ul>

                                <p style={{
                                    color: "#fff",
                                    fontSize: "1.1rem",
                                    lineHeight: "1.8",
                                    fontFamily: "Rubik, sans-serif",
                                    marginTop: "2rem"
                                }}>
                                    If you’re building or publishing in VR, we’d love to hear your challenges and ideas.<br />
                                    <strong>Let’s make VR growth more transparent, data-driven, and founder-friendly</strong>
                                </p>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    </React.Fragment>
    )
}

export default AboutUs

